// Shared drawer state machine used by MenuDrawer (menu-drawer.js) and
// FilterDrawer (filter-drawer.js): [open] attribute + .closing class for CSS
// transitions, overlay click to close, transitionend teardown, body scroll lock,
// and an Escape handler subclasses can attach when appropriate.
//
// Assigned via window guard (not a top-level class declaration) so the file is
// safe to include from more than one snippet on the same page.
window.DrawerBase =
  window.DrawerBase ||
  class extends HTMLElement {
    // Subclasses call this once with their overlay and sliding-content elements.
    initDrawer({ overlay, content }) {
      overlay.addEventListener('click', () => this.close());

      content.addEventListener('transitionend', (event) => {
        if (event.target !== content) return;
        if (this.classList.contains('closing')) {
          this.classList.remove('closing');
          this.removeAttribute('open');
          this.onAfterClose();
        }
      });

      this.onEscapeKeydown = (event) => {
        if (event.key === 'Escape') this.close();
      };
    }

    get isOpen() {
      return this.hasAttribute('open') && !this.classList.contains('closing');
    }

    open() {
      if (this.isOpen) return;

      this.classList.remove('closing');
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      this.offsetHeight; // flush styles so the CSS open transition plays
      this.onAfterOpen();
    }

    close() {
      if (!this.isOpen) return;

      this.classList.add('closing');
      document.body.style.overflow = '';
      this.onAfterCloseStart();
    }

    // Hooks for subclasses.
    onAfterOpen() {}
    onAfterCloseStart() {}
    onAfterClose() {}
  };
